/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { isObject } from '../is-object/is-object.js';

var isEmptyObject = function isEmptyObject(obj) {
  return isObject(obj) && Object.keys(obj).length === 0;
};

export { isEmptyObject };
//# sourceMappingURL=is-empty-object.js.map
